// `cursor: not-allowed` is a legacy literal copied from `InlineInput`'s own `canEdit === false`
// rendering (libs/webui/input/src/InlineInput/index.tsx) — flagged here, not re-copied as a new
// inline style; no Bootstrap utility class covers this cursor value.
.disabledAddress {
  cursor: not-allowed;
}
